import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import styles from "./PageLayout.module.scss";

/**
 * PageLayout provides a consistent page structure: optional back link, title, subtitle, and content area.
 * Use for wizard and form pages that need a clear page chrome.
 */
export default function PageLayout({
  title,
  subtitle,
  backTo,
  onBack,
  backLabel = "← Back",
  children,
  className = "",
}) {
  const navigate = useNavigate();
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backTo) {
      navigate(backTo);
    }
  };
  const showBack = Boolean(backTo || onBack);

  return (
    <div className={`${styles.root} ${className}`.trim()}>
      {showBack && (
        <Button
          type="button"
          variant="link"
          className={styles.backBtn}
          onClick={handleBack}
        >
          {backLabel}
        </Button>
      )}
      {(title || subtitle) && (
        <header className={styles.header}>
          {title && <h1 className={styles.title}>{title}</h1>}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </header>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
